import React, { useEffect } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  Avatar,
  Box,
  Divider,
  Drawer,
  Hidden,
  List,
  Typography,
  makeStyles
} from '@material-ui/core';
import Admin from './Admin';

import Api from '../../../Api';
import Color from '../../../utils/colors';

const useStyles = makeStyles(() => ({
  mobileDrawer: {
    width: 256,
    backgroundColor: Color.sidebarColor, // backgroud color ng side bar
    color: Color.sidebartitleColor,
    '& .MuiSvgIcon-root' : {
      color: Color.iconSidebarColor,
    },
  },
  desktopDrawer: {
    width: 256,
    top: 64,
    backgroundColor: Color.sidebarColor, // backgroud color ng side bar
    height: 'calc(100% - 64px)',
    color: Color.sidebartitleColor,
    '& .MuiSvgIcon-root' : {
      color: Color.iconSidebarColor,
    },

  },
  avatar: {
    cursor: 'pointer',
    width: 64,
    height: 64,
  // backgroud color ng side bar
  },
  Head:{
    backgroundColor: '#3e4396',
    color: 'white'
  },
  textColor:{
      color: 'white'
      //088c3f
  },
  button_blue:{
    background: '#252728',///'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)',
    //boxShadow: '0 3px 5px 2px rgba(33, 203, 243, .3)',//'0 3px 5px 2px rgba(255, 105, 135, .3)',
  },

}));

  const NavBar = ({ onMobileClose, openMobile }) => {
  const classes = useStyles();
  const location = useLocation();

  
  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  const content = (
    <Box
      height="100%"
      display="flex"
      flexDirection="column"
    
    >
      {/* Sticky Top Section */}
      <Box
  sx={{
    position: 'sticky',
    top: 0,
    zIndex: 10,
    backgroundColor: '#1f1f1f',
    textAlign: 'center',
    borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
    paddingY: 1,
  }}
  className={classes.button_blue}
>
  <Box
    display="flex"
    flexDirection="column"
    alignItems="center"
    justifyContent="center"
    sx={{ gap: 0.5 }}
  >
    <Avatar
      component={RouterLink}
      to="/app/account"
      sx={{
        width: 48,       // smaller avatar
        height: 48,
        mb: 0.5,
      }}
    />
    <Typography
      variant="body2"
      className={classes.textColor}
      sx={{ fontSize: 13, lineHeight: 1 }}
    >
      {Api?.request?.username || "Username"}
    </Typography>
    <Typography
      variant="caption"
      className={classes.textColor}
      sx={{ fontSize: 11, lineHeight: 1 }}
    >
      {Api?.request?.jobTitle || "Job Title"}
    </Typography>
  </Box>
</Box>


  
      {/* Scrollable Menu */}
      <Box
        sx={{
          flexGrow: 1,
          overflowY: 'auto',
          px: 1,
          height: 500
        }}
      >
        <List>
         <Admin />
        </List>
      </Box>
  
      {/* Footer */}
      <Divider/>
      <Box
        sx={{

          py: 1,
          textAlign: 'center',
          backgroundColor: Color.sidebarColor,
          borderTop: '1px solid rgba(255, 255, 255, 0.1)',
        }}
      >
        <Typography
          variant="body2"
          style={{ color: Color.green }}
        >
          © {new Date().getFullYear()}
        </Typography>
      </Box>
    </Box>
  );
  

  return (
    
    <>
      <Hidden lgUp>
        <Drawer
          anchor="left"
          classes={{ paper: classes.mobileDrawer }}
          onClose={onMobileClose}
          open={openMobile}
          variant="temporary"
        >
          {content}
        </Drawer>
      </Hidden>
      <Hidden mdDown>
        <Drawer
          anchor="left"
          classes={{ paper: classes.desktopDrawer }}
          open
          variant="persistent"
        >
          {content}
        </Drawer>
      </Hidden>
    </>
  );
};

NavBar.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool
};

NavBar.defaultProps = {
  onMobileClose: () => {},
  openMobile: false
};

export default NavBar;
